module.exports = __webpack_public_path__ + "img/img_031@2x.d50e3943.png";